"use client";

import { useSyncExternalStore } from "react";

const subscribe = () => () => {};

/**
 * Reads a browser-only value (storage, `window.location`) during render. The
 * server render and hydration get `serverValue`, so markup still matches; a
 * component mounted after hydration (client-side navigation) reads the browser
 * on its first render, with no effect and no second render.
 *
 * `read` is not subscribed to anything: it re-runs on each render, so it must
 * return a primitive (compared with `Object.is`). Writes made by the component
 * itself need their own state next to it.
 */
export function useClientValue<T extends string | number | boolean | null>(
  read: () => T,
  serverValue: T,
): T {
  return useSyncExternalStore(subscribe, read, () => serverValue);
}
